export default __webpack_public_path__ + "static/media/icons-subscribe.d9877ac0.svg";